import { render, staticRenderFns } from "./RegistrationManualVerificationLoadingPage.vue?vue&type=template&id=3bb0844a&scoped=true"
import script from "./RegistrationManualVerificationLoadingPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationManualVerificationLoadingPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationManualVerificationLoadingPage.vue?vue&type=style&index=0&id=3bb0844a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb0844a",
  null
  
)

export default component.exports